import script from "./CreateFontStep1.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateFontStep1.vue?vue&type=script&setup=true&lang=js"

import "./CreateFontStep1.vue?vue&type=style&index=0&id=647b73b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647b73b6"]])

export default __exports__